export enum TrackingPageTypeWithId {
  /**
   * Category product listing page
   */
  Category = 'category',

  /**
   * Page showing the list of child categories for a given category
   */
  CategoryOverview = 'categoryOverview',

  ADP = 'adp',
  AdpQuickView = 'adpQuickView',

  Story = 'story',

  Idol = 'idol',

  ODP = 'odp',

  Brand = 'brand',
  BrandDiscover = 'brand_discover',
  HelpCenterSection = 'helpCenterSection',
  HelpCenterArticle = 'helpCenterArticle',
  SeoStreamPage = 'seoStreamPage',
  // MultiBrand = 'MultiBrand', // Document what this is
  // BrandPremium = 'brandPremium', //Don't know this here, should be moved to brand page detail event

  // CMS custom pages
  CustomPage = 'customPage',

  // hot drops
  DropOverview = 'dropOverview',
  DropDetails = 'dropDetails',

  // live shopping
  LiveShopping = 'liveshopping',

  OSP = 'osp',
  // login modal
  LoginModal = 'login_modal', // A page where the user is presented with a login form.
  StoryCluster = 'storyCluster',
}

export enum TrackingPageTypeWithoutId {
  Browse = 'browse', // Desktop only?
  ProductRecoPage = 'productRecoPage',
  BrandOverview = 'brandOverview',
  IdolOverview = 'idolOverview',
  StoryOverview = 'storyOverview',
  OutfitOverview = 'outfitOverview',

  Navigation = 'navigation',
  DiscoveryNewOutfits = 'discoveryNewOutfits',
  DiscoveryAllOutfits = 'discoveryAllOutfits',
  DiscoveryIdols = 'discoveryIdols',

  Basket = 'basket',

  BasketFlyout = 'basket_flyout',
  Wishlist = 'wishlist',
  Search = 'search', // Search Result Page
  SemanticSearch = 'semantic_results', // new search results page
  OSP = 'osp', // Order Success Page
  Register = 'register', // A page where the user is presented with a registration form.
  OrderInfo = 'orderInfo', // A page where the user is presented with shipping and other information on his previous orders.
  Newsletter = 'newsletter', //
  Error = 'error', // A page that shows that an error occured.
  NotFound = '404', // A page that shows a 404
  Corporate = 'corporate', // The page contains information about the company. (About Us, Company)
  Blog = 'blog',
  Info = 'info', // A page that provides information about the app, the shop, etc. (e.g. terms & conditions, faq, impress, etc.).
  HelpCenter = 'helpCenter',
  HelpCenterContact = 'helpCenterContact',
  HelpCenterSearchResult = 'helpCenterSearchResult',
  Other = 'other', // A page where no other content group applies.
  Teaser = 'teaser', // for teaser pages
  highlightPage = 'highlight_page',

  // checkout
  Checkout = 'checkout', // The page is part of the checkout process.
  CheckoutLogin = 'checkout:login',
  CheckoutRegistration = 'checkout:registration',
  CheckoutAddressInformation = 'checkout:address-information',
  CheckoutDeliveryOptions = 'checkout:delivery-options',
  CheckoutCreateShippingAddress = 'checkout:create-shipping-address',
  CheckoutBillingAddress = 'checkout:billing-address address-information',
  CheckoutPaymentSection = 'checkout:payment-selection',

  // native account area
  NavigationAccountArea = 'account_area:navigation',
  OrdersOverview = 'account_area:orders_overview',
  OrdersDetailView = 'account_area:orders_detailview',
  TrackShipment = 'account_area:track_shipment',
  InitiateReturn = 'account_area:initiate_return',
  InitiatePickReturn = 'account_area:initiate_pick_return',
  ReturnsOverview = 'account_area:returns_overview',
  ReturnsDetailView = 'account_area:returns_detailview',
  BankDataCOD = 'account_area:bank_data_COD',
  PaymentMethods = 'account_area:payment methods',
  GiftCards = 'account_area:giftcards',
  Addresses = 'account_area:addresses',
  LoginSecurity = 'account_area:login_security',
  SizeFinder = 'account_area:sizefinder',
  Favorites = 'account_area:favorites',
  FavoritesIdols = 'account_area:favorites_idols',
  FavoritesBrands = 'account_area:favorites_brands',
  Help = 'account_area:help',
  Settings = 'account_area:settings',
  OffCanvas = 'offCanvas',
  OffCanvasNavigation = 'offCanvasNavigation',

  // hot drops
  DropOverview = 'dropOverview',
  DropDetails = 'dropDetails',

  // live shopping
  LiveShopping = 'liveshopping',
  LiveShoppingPlayer = 'liveshoppingPlayer',

  CouponLandingPage = 'coupon_landing_page',
  Streetwear = 'streetwear',
  Sportswear = 'sportswear',
}
